import React from "react";
import { TextField, MenuItem, FormControl as MuiFormControl } from "@mui/material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { getThemeTextColor, getThemeBackgroundColor } from "../utils/themeUtils";
import { useTheme } from "@mui/material/styles";

const FormControlSpacing = styled(MuiFormControl)(spacing);
const FormControl = styled(FormControlSpacing)``;

const SelectWrapper = ({ name, rowIndex, selectedKey, optional1, options, handleChange, ...otherProps }) => {
  const theme = useTheme();
  const handleChangeInt = (event) => {
    const { value } = event.target;
    handleChange(value, rowIndex);
  };

  const configSelect = {
    ...otherProps,
    select: true,
    variant: "outlined",
    onChange: handleChangeInt,
    fullWidth: true,
    sx: {
      "& .MuiOutlinedInput-root": {
        ...getThemeBackgroundColor(theme),
        ...getThemeTextColor(theme),
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "divider",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "primary.main",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "primary.main",
      },
    },
  };

  return (
    <React.Fragment>
      <FormControl fullWidth my={2}>
        <TextField
          {...configSelect}
          defaultValue={selectedKey}
          SelectProps={{
            displayEmpty: true,
            MenuProps: {
              PaperProps: {
                sx: {
                  ...getThemeBackgroundColor(theme),
                  ...getThemeTextColor(theme),
                  "& .MuiMenuItem-root": {
                    ...getThemeTextColor(theme),
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "action.selected",
                    },
                  },
                },
              },
            },
          }}
        >
          {optional1
            ? options
                .filter((prod) => prod.countryCode === optional1)
                .map(({ key, value, disabled }, index) => (
                  <MenuItem key={key} value={key} disabled={disabled}>
                    {value}
                  </MenuItem>
                ))
            : options.map(({ key, value, disabled }, index) => (
                <MenuItem key={key} value={key} disabled={disabled}>
                  {value}
                </MenuItem>
              ))}
        </TextField>
      </FormControl>
    </React.Fragment>
  );
};

export default SelectWrapper;
